import { Agreement } from '../types'

// CONFIGURACIÓN SIMULADA (En producción, esto viene de variables de entorno)
const MP_CLIENT_ID = 'APP_USR-1234567890'
const REDIRECT_URI =
  typeof window !== 'undefined' ? `${window.location.origin}/mp/callback` : ''

/**
 * Genera la URL de autorización para Mercado Pago Connect (OAuth).
 * El prestador hace clic aquí para vincular su cuenta.
 */
export function getConnectUrl(providerId: string): string {
  // BACKEND REQUIRED: En producción, el 'state' debe ser un token seguro generado por el backend
  // para prevenir ataques CSRF, y debe mapear al providerId.
  const state = btoa(JSON.stringify({ providerId, timestamp: Date.now() }))

  return `https://auth.mercadopago.com/authorization?client_id=${MP_CLIENT_ID}&response_type=code&platform_id=mp&state=${state}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`
}

/**
 * Simula el intercambio del código OAuth por un access_token.
 * BACKEND REQUIRED: Esta función DEBE ejecutarse en el servidor.
 * El frontend envía el 'code' al backend, el backend llama a la API de MP con el client_secret,
 * obtiene el access_token y el refresh_token, los guarda de forma segura, y devuelve el user_id.
 */
export async function connectProviderAccount(
  code: string,
  state: string,
): Promise<{ mp_user_id: string }> {
  // Simulamos latencia de red
  await new Promise((resolve) => setTimeout(resolve, 1500))

  // En este prototipo, simplemente generamos un ID falso de Mercado Pago
  const fakeMpUserId = `MP_USER_${Math.floor(Math.random() * 1000000)}`

  return { mp_user_id: fakeMpUserId }
}

/**
 * Simula la creación de una Preferencia de Pago con Split (Marketplace Fee).
 * BACKEND REQUIRED: Esta función DEBE ejecutarse en el servidor usando el access_token de la plataforma (Agreexa).
 */
export async function createPreference(
  agreement: Agreement,
  providerMpUserId: string,
): Promise<{ init_point: string; id: string }> {
  await new Promise((resolve) => setTimeout(resolve, 1000))

  // DOCUMENTACIÓN DEL PAYLOAD REAL PARA EL BACKEND:
  /*
  const payload = {
    items: [
      {
        id: agreement.agreement_code,
        title: agreement.title,
        description: agreement.description || 'Servicio protegido por Agreexa',
        quantity: 1,
        unit_price: agreement.amount,
        currency_id: agreement.currency
      }
    ],
    payer: {
      email: agreement.client_email,
      name: agreement.client_name || undefined
    },
    // AQUÍ ESTÁ LA MAGIA DEL SPLIT PAYMENT:
    marketplace_fee: agreement.amount * agreement.commission_rate, // 5% para Agreexa
    collector_id: providerMpUserId, // El dinero va DIRECTO a la cuenta del prestador
    
    back_urls: {
      success: `${DOMAIN}/payment/success?code=${agreement.agreement_code}`,
      pending: `${DOMAIN}/payment/pending?code=${agreement.agreement_code}`,
      failure: `${DOMAIN}/payment/failure?code=${agreement.agreement_code}`
    },
    auto_return: 'approved',
    notification_url: `${API_DOMAIN}/webhooks/mercadopago`, // Para recibir actualizaciones de estado
    external_reference: agreement.agreement_code
  }
  
  // Llamada a la API de MP: POST https://api.mercadopago.com/checkout/preferences
  // Headers: Authorization: Bearer APP_USR-AGREEXA_ACCESS_TOKEN
  */

  const fakePreferenceId = `pref_${Math.random().toString(36).substring(7)}`

  // En el prototipo, redirigimos directamente a nuestra página de éxito simulada
  // En producción, esto sería la URL de checkout de Mercado Pago (init_point)
  const simulatedInitPoint = `/payment/success?code=${agreement.agreement_code}&simulated=true`

  return {
    id: fakePreferenceId,
    init_point: simulatedInitPoint,
  }
}
